import { render } from "./ExpectationsSection.vue?vue&type=template&id=e2828d66&scoped=true"
import script from "./ExpectationsSection.vue?vue&type=script&lang=js"
export * from "./ExpectationsSection.vue?vue&type=script&lang=js"

import "./ExpectationsSection.vue?vue&type=style&index=0&id=e2828d66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2828d66"]])

export default __exports__